import {loadingBarMiddleware, loadingBarReducer} from 'react-redux-loading-bar';
import {browserHistory} from 'react-router';
import {routerMiddleware, routerReducer} from 'react-router-redux';
import {
  authReducer,
  currentNavPageReducer,
  languageReducer,
  sourcesTokensReducer,
  orderLineReducer,
  appsReducer,
  appRefFilterReducer,
  subMenuDirectionReducer,
  statisticsFilterReducer,
  getFacturationInfoReducer,
  getPaymentInfoReducer,
  getNotPaidInvoicesReducer,
  getRecapByDayReducer,
  getPaidInvoicesDetailsReducer,
  getUnpaidInvoicesDetailsReducer,
  notificationsReducer,
  setApplication,
  getDocumentsToBeExportedEfffZip,
  getUserCardListReducer,
  mangoPayReducer,
  CardRegistrationReducer,
  eventStatsFilterReducer,
  getEventStatsDataTableReducer,
  countEventAppTypeReducer,
  getGlobalEventStatsReducer,
  getSeasonsReducer,
  getDoublePaymentReducer,
  budgetManagementReducer
} from 'reducers';
import {applyMiddleware, combineReducers, compose, createStore} from 'redux';
import {createLogger} from 'redux-logger';
import promise from 'redux-promise-middleware';
import thunk from 'redux-thunk';


export const configureStore = (initialState = {}) => {
  const reducer = combineReducers({
    auth: authReducer,
    params: combineReducers({
      lng: languageReducer,
      currentNavPage: currentNavPageReducer,
      sourcesTokens: sourcesTokensReducer,
      subMenuDirection: subMenuDirectionReducer,
      application: setApplication,
    }),
    routing: routerReducer,
    loadingBar: loadingBarReducer,
    orderLines:orderLineReducer,

    filters: combineReducers({
      statisticsFilter: statisticsFilterReducer,
      eventStatsFilter: eventStatsFilterReducer,
    }),
    appRefFilter : appRefFilterReducer,
    apps: appsReducer,
    facturationInfos : getFacturationInfoReducer,
    paymentInfos : getPaymentInfoReducer,
    notPaidInvoices : getNotPaidInvoicesReducer,
    notPaidInvoicesDetails : getUnpaidInvoicesDetailsReducer,
    documentsToBeExportedEfffZip : getDocumentsToBeExportedEfffZip,
    doublePaymentReducer : getDoublePaymentReducer,
    recapByDay : getRecapByDayReducer,
    paidInvoicesDetails : getPaidInvoicesDetailsReducer,
    userCardListReducer: getUserCardListReducer,
    mangoPay: mangoPayReducer,
    cardRegistration: CardRegistrationReducer,
    eventStatsDataTable: getEventStatsDataTableReducer,
    eventAppType: countEventAppTypeReducer,
    eventStatsGlobal: getGlobalEventStatsReducer,
    seasons: getSeasonsReducer,
    budgetManagement: budgetManagementReducer
  });

  return createStore(reducer, initialState, compose(applyMiddleware(routerMiddleware(browserHistory), thunk, createLogger(),  promise(), loadingBarMiddleware()),
    window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f,
  ));
};

export {browserHistory};  // export hashHistory to use the same instance in app.js



// WEBPACK FOOTER //
// ./app/store/configureStore.js